<template>
  <!-- <StartupListPage :followed-only="true" /> -->
  <div>
    <StartupListTopNav />
    <ScrollTopButton />
    <div class="mt-6 pane" v-loading="fetchShortlistsInProgress">
      <div class="grid grid-cols-2 gap-4">
        <ShortlistList
          :shortlists="shortlists.filter((s) => !s.organization_id)"
          @update="onShortlistUpdate"
          @create="onShortlistCreate"
          @remove="onShortlistRemove"
        >
          <template v-slot:header>
            <h3 class="text-gray-300 text-base">
              Private shortlists
            </h3>
            <p class="text-gray-200 text-xs">
              Those are your private shortlists
            </p>
          </template>
        </ShortlistList>
        <ShortlistList
          v-if="org.id"
          :shortlists="shortlists.filter((s) => s.organization_id)"
          :organization-id="org.id"
          @update="onShortlistUpdate"
          @create="onShortlistCreate"
          @remove="onShortlistRemove"
        >
          <template v-slot:header>
            <h3 class="text-gray-300 text-base">
              Organization shortlists
            </h3>
            <p class="text-gray-200 text-xs">
              Those shortlists are shared with your organization ({{
                org.name
              }})
            </p>
          </template>
        </ShortlistList>
      </div>
    </div>
  </div>
</template>

<script>
import StartupListPage from 'modules/startup-list/StartupListPage.vue'
import StartupListTopNav from 'modules/startup-list/StartupListTopNav.vue'
import ShortlistList from './ShortlistList.vue'
import { useShortlists } from '@/states/shortlists/useShortlists'
import $message from 'services/messages'

export default {
  components: {
    StartupListPage,
    StartupListTopNav,
    ShortlistList,
  },
  setup() {
    const {
      shortlists,
      fetchShortlists,
      fetchShortlistsInProgress,
      createShortlist,
      setStartupShortlists,
      isSetStartupShortlistsInProgress,
      org,
    } = useShortlists()
    fetchShortlists()

    const onShortlistCreate = async () => {
      await fetchShortlists()
      $message({ type: 'success', message: 'Shortlist added' })
    }

    const onShortlistUpdate = async () => {
      await fetchShortlists()
      $message({ type: 'success', message: 'Shortlist updated' })
    }

    const onShortlistRemove = async () => {
      await fetchShortlists()
      $message({ type: 'success', message: 'Shortlist removed' })
    }

    return {
      shortlists,
      org,
      onShortlistCreate,
      onShortlistUpdate,
      onShortlistRemove,

      fetchShortlistsInProgress,
    }
  },
}
</script>
